document.addEventListener('DOMContentLoaded', function() {
  function resizeGridItem(item) {
    const grid = document.querySelector('.masonry-collage');
    if (!grid) return;

    const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('gap'));

    const contentHeight = item.querySelector('img') ? item.querySelector('img').getBoundingClientRect().height : 0;

    const rowSpan = Math.ceil((contentHeight + rowGap) / (rowHeight + rowGap));
    item.style.gridRowEnd = 'span ' + rowSpan;
    item.style.height = 'auto'; // Ensure height is auto
    item.style.minHeight = '100%'; // Ensure min-height is 100%
  }

  function resizeAllGridItems() {
    const allItems = document.querySelectorAll('.masonry-collage .masonry-item');
    allItems.forEach(item => resizeGridItem(item));
  }

  window.addEventListener('resize', resizeAllGridItems);

  const allImages = document.querySelectorAll('.masonry-collage .masonry-item img');
  allImages.forEach(img => {
    img.addEventListener('load', function() {
      resizeGridItem(img.closest('.masonry-item'));
    });
  });

  resizeAllGridItems();
});